import L from "leaflet";

import 'leaflet.pm'
import 'leaflet.pm/dist/leaflet.pm.css'

import "leaflet-velocity/dist/leaflet-velocity";
import "leaflet-velocity/dist/leaflet-velocity.css";   //  风场图css

import "leaflet.markercluster/dist/MarkerCluster.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css"
import "leaflet.markercluster";

import "./ruijingBF"
import 'leaflet.chinatmsproviders'
import "leaflet-tilelayer-colorizr"

// 解决默认 maker 无法显示的问题
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";


import icon0 from '../../assets/industrial/site-0-0.svg'
import icon1 from '../../assets/industrial/site-0-1.svg'
import icon2 from '../../assets/industrial/site-0-2.svg'
import icon3 from '../../assets/industrial/site-0-3.svg'
import icon4 from '../../assets/industrial/site-0-4.svg'


import features  from "./china"



let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
});
L.Marker.prototype.options.icon = DefaultIcon;


//定义地图实例
const newMap = (domId, option) => {
    let map = L.map(domId, option)
    return map
}
//切片图层
const createLayers = (map, url, option) => {
    let newLeayer = L.tileLayer(url, option)
    newLeayer.addTo(map)
    return newLeayer
}
//leaflet.ChineseTmsProviders插件加载地图
const chinaLayers = (map, url, option) => {
    let chinaLeayer = L.tileLayer.chinaProvider(url, option)
    chinaLeayer.addTo(map)
    return chinaLeayer
}

//leaflet.ChineseTmsProviders插件加载地图
const blueColorizr = (map) => {
    return   L.tileLayer.colorizr("http://webst04.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}", {
        maxZoom: 18,
        minZoom: 3,
        colorize: function (pixel) {
            // 这个方法用来调整所有的图片上的rgb值，pixel是图片原有的rgb值
            pixel.r += 25;
            pixel.g += 25;
            pixel.b += 112;
            return pixel;
        }
    }).addTo(map);

}


const  provinceBorder = (map,params) =>{

        let provinceBorder = L.geoJSON(params.features ? params.features : features,
        {style: {color: params.color ? params.color : '#409EFF',
                fillOpacity:0.1,weight: 1}}
    );
    provinceBorder.addTo(map);
    return provinceBorder
}

const  allCity = (map) =>{

    fetch('https://geo.datav.aliyun.com/areas_v3/bound/211300.json')
        .then(response => {
            console.log(response)
            if (response.ok) {
                return response.json(); // 将响应转换为JSON
            }
            throw new Error('Network response was not ok.');
        })
        .then(jsonData => {
            console.log(jsonData); // 这里是JSON对象

            let provinceBorder = L.geoJSON(jsonData,
                {style: {color: '#409EFF',
                        fillOpacity:0.4,weight: 1}}
            );
            console.log(features)
            provinceBorder.addTo(map);
            return provinceBorder

        })
        .catch(error => {
            console.error('Error fetching data: ', error);
        });

}

const cityColor = (map,params) =>{
    let provinceBorder = L.geoJSON(params.jsonData,
        {style: {color: params.color,
                fillOpacity:0.4,weight: 1}}
    );

    // provinceBorder.addTo(map);
    return provinceBorder
}

/**
 * https://www.npmjs.com/package/@ruijingrs/leaflet-raster-tile-layer
 *
 * 锐景瓦片图层
 *
 * */


const rujingLayer = (map,data,features) =>{
    const domainAndColor = [{min: 0, max: 5, color: "#34b300"}, {min: 5, max: 10, color: "#3ecf00"}, {
        min: 10,
        max: 15,
        color: "#46e800"
    }, {min: 15, max: 20, color: "#99fd0b"}, {min: 20, max: 25, color: "#a9ff00"}, {
        min: 25,
        max: 30,
        color: "#daff00"
    }, {min: 30, max: 35, color: "#fdff00"}, {min: 35, max: 40, color: "#fcea00"}, {
        min: 40,
        max: 45,
        color: "#fad200"
    }, {min: 45, max: 50, color: "#f9bd00"}, {min: 50, max: 60, color: "#f78900"}, {
        min: 60,
        max: 70,
        color: "#f66400"
    }, {min: 70, max: 80, color: "#f50000"}, {min: 80, max: 90, color: "#c60000"}, {
        min: 90,
        max: 100,
        color: "#9d0056"
    }, {min: 100, max: 110, color: "#830024"}]
   let geojson = L.geoJSON(features);
    const ruLayer = L.TileLayer.rasterTile({
        // type: 'PM25',
        // time: '2024/03/20 00:00:00',

        type: data.type,
        time: data.time,
        agg: 'daily',
        // token: 'ca39913a9b834bc49ceeb27cfca7496f',
        token: localStorage.getItem('token'),
        // mode: 'show',
        pickTrigger:"click",
        opacity:1,
        pickDataCallback: (value) => {
            console.log(value)
            // document.getElementById('value').innerHTML = value || '';
        },
        minNativeZoom: 0,
        // 重要，瓦片最大缩放级别，不设置会导致数据不显示
        maxNativeZoom: 7,
        polygons:geojson.getLayers(),
        domainAndColor:domainAndColor,
        // 设置正确的bounds可过滤不需要的瓦片请求，有效提高瓦片加载效率
        // bounds:henan.features[0].geometry.coordinates
        bounds: [
            [18.389163, 73.492109],
            [53.373805, 124.057692],
        ],
    });

    ruLayer.addTo(map)
    // map.addLayer(layer);


    return ruLayer
}




//  插入图片
const imageBounds = (map,url) =>{
    let imageBounds =[[28.0058,120.2855], [29.3469,121.9386]];//图片的经纬度范围，西南角点,东北角点(纬度、经度)
    // let imageBounds =[[10.01, 60.42], [57.35, 152.48]];//图片的经纬度范围，西南角点,东北角点(纬度、经度)
    // let imageUrl='https://graph.zq12369.cn/AQI/hour/CUACE_09km_AQI_station_2022-01-24%2016:00:00.png';//图片的地址
    // let imageUrl=require('../be16cfa54c405e71977df69e89f3105.png');//图片的地址
    let imageUrl=url;//图片的地址
    let imageLayer =L.imageOverlay(imageUrl, imageBounds,{opacity:1});//opacity是透明度
    // imageLayer.addTo(map)
    // return imageLayer
    map.addLayer(imageLayer);

    return imageLayer
}


//  风场图
const velocity = (map, option) => {
    let velocity = L.velocityLayer(option)
    velocity.addTo(map)
    return velocity
}




// 点组合
const createMakerCluster = () => {
    // return L.markerClusterGroup();   //  聚合
    return L.layerGroup();       // 组合
};

const createMakerCluster2 = () => {
    return L.markerClusterGroup();   //  聚合
    // return L.layerGroup();       // 组合
};


// 宿州站点
const createMakerByLatlng = (latlng, params) => {

    let html = `<div class="marker2Box">
    `


            switch (params.psStatus) {
                case 0:
                    html+=`<img src="${icon0}" alt="">`
                    break
                case 1:
                    html+=`<img src="${icon1}" alt="">`
                    break
                case 2:
                    html+=`<img src="${icon2}" alt="">`
                    break
                case 6:
                    html+=`<img src="${icon3}" alt="">`
                    break
                case 7:
                    html+=`<img src="${icon4}" alt="">`
                    break
            }

        html+=`
</div>`;

    return L.marker(latlng, {icon: myIcon(html)})
};


// 工业园站点
const createMakerByLatlng2 = (latlng, params) => {

    let html = `<div class="marker2Box">
    `
    switch (params.online) {
        case 0:
            html+=`<img src="${icon4}" alt="">`
            break
        case 1:
            html+=`<img src="${icon0}" alt="">`
            break
    }

    html+=`
</div>`;

    return L.marker(latlng, {icon: myIcon(html)})
};






// 创建工业源点
const createMaker2ByLatlng = (latlng, params) => {

    let html = `<div class="marker2Box">
        <img src="${icon0}" alt="">
    </div>`;

    return L.marker(latlng, {icon: myIcon(html)})
};


//  随机点坐标
const getRandomLatLng = map => {
    let bounds = map.getBounds(),
        southWest = bounds.getSouthWest(),
        northEast = bounds.getNorthEast(),
        lngSpan = northEast.lng - southWest.lng,
        latSpan = northEast.lat - southWest.lat;

    return L.latLng(
        southWest.lat + latSpan * Math.random(),
        southWest.lng + lngSpan * Math.random()
    );
};


const myIcon = (text) => {
    return L.divIcon(
        {
            html: text,
            iconSize: [24, 24],
            className: 'custom-color-icon'
        });
};

//
// const myIcon = L.divIcon(
//     {
//         html:'2020',
//         iconSize: [30, 30],
//         className: 'custom-color-icon'
//     });

const customTowerIcon = () => {
    let svgContent = ``;
    // let divContent = `<p style="color:white">${this.placeName}</p>`;
    let customColorIcon = L.divIcon({
        iconSize: [30, 30],
        className: "custom-color-icon",
        html: svgContent
    });
    return customColorIcon;
}

//  画线

const  createLine = (latlngs,color)=>{
    var polyline = L.polyline(latlngs, {color: color});
    return polyline
}


// 省份刷色



export default {
    newMap,
    createLayers,
    chinaLayers,
    blueColorizr,
    rujingLayer,
    velocity,
    createMakerCluster,
    createMakerCluster2,
    getRandomLatLng,
    createMakerByLatlng,
    createMakerByLatlng2,
    createMaker2ByLatlng,
    customTowerIcon,
    imageBounds,
    provinceBorder,
    createLine,
    allCity,
    cityColor
}
